export default __webpack_public_path__ + "static/media/autoatencion.9674a6d9.png";